import GuiContext from "config/context/guiContext";
import PluginsContext from "config/context/pluginsContext";
import { useCallback, useContext, useState } from "react";

const initialServerStatus = {
    response: null,
    loading: false,
    error: null,
}

export const useActivatePlugin = () => {
    const { updatePluginsContext } = useContext(PluginsContext);
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const {
        selected: { selectedAccount, selectedServer },
        userData: { guiname, id: accountId },
        URL
    } = useContext(GuiContext);

    const activatePlugin = async ({ id }) => {

        setLoading(true);

        try {
            const res = await fetch(`${URL}/api/plugins/turn`, {
                method: 'POST',
                // Bez ovoga ruta vraća 401 — vidi `requireSessionMiddleware`.
                credentials: 'include',
                headers: { 'Content-Type': 'application/json', },
                body: JSON.stringify({
                    account_id: accountId,
                    guiname: guiname,
                    plugin_id: id,
                    plugin_state: true,
                    server_url: selectedServer
                }),
            });

            const data = await res.json();
            setResponse(data);
            
            if (data?.status) {
                updatePluginsContext({ "status": true, "plugin": id, "guiname": selectedAccount });
            } else {
                setError(data?.message);
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    };

    const resetServerStatus = useCallback(() => {
        setLoading(initialServerStatus.loading);
        setResponse(initialServerStatus.response);
        setError(initialServerStatus.error);
    }, [])

    return {
        response,
        loading,
        error,
        activatePlugin,
        resetServerStatus
    };
};